module.exports = __webpack_public_path__ + "img/house-sm-left.524d0eb2.png";